import { FC } from "react";

import { Image } from "mui-image";

import empatLogo from "../../assets/images/empatLogo.svg";

export const EmpatLogo: FC = () => (
  <Image alt="Empat tech company logo" src={empatLogo} duration={0} />
);
